module.exports = __webpack_public_path__ + "static/ogPreview-45fd2c2961206a601e4cbf7398bc06aa.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/enterprise/ogPreview.png
// module id = 511
// module chunks = 168707334958949